import {InputTextV2} from '@prtimes-basis/input';
import {
  FormField,
  useFormField,
} from '@/features/company-registration/steps/input-step/form-field';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function PresidentTitleField() {
  return (
    <FormField.Root name='companyInfo.presidentTitle'>
      <Body />

      <FormField.Error />

      <FormField.Description>
        個人事業主の方は「事業主」とご入力ください
      </FormField.Description>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField({
    hasDescription: true,
  });

  return (
    <InputTextV2
      required
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
